/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { Modal, Button, Col } from 'react-bootstrap';
import { useState } from 'react';
import { useLoading } from 'providers/PageLoadingProvider';
import apiEndpoints from 'constants/apiEndpoints';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import CustomModal from 'components/custom/modal/CustomModal';
import { Row } from 'react-bootstrap';
import ToolTipButton from 'components/common/TooltipButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import useChallanCheck from 'views/challan/coal-iron/useChallanCheck';
import useConfirmationModal from 'views/challan/coal-iron/useConfirmationModal';

const EmployeeLatePunchinDetailModal = ({
  show,
  handleClose,
  data,
  handleLoading,
  refreshData
}) => {
  const { acceptCheck, rejectCheck } = useConfirmationModal(
    apiEndpoints.employee.LatePunchApproval,
    'Late Punch-In'
  );

  const userDataJson = window.localStorage.getItem('kerpUserData2.1');
  const parsedUserData = JSON.parse(userDataJson || '{}');

  const handleApproval = async value => {
    handleClose();
    acceptCheck(
      data,
      {
        // challan_no: data?.data?.challan_no,
        approval_id: data?.id,
        approved_by: parsedUserData.user_id,
        status: 'Approved'
      },
      handleLoading,
      refreshData
    );
  };

  const handleReject = async value => {
    handleClose();
    rejectCheck(
      data,
      {
        // challan_no: data?.data?.challan_no,
        approval_id: data?.id,
        approved_by: parsedUserData.user_id,
        status: 'Rejected'
      },
      handleLoading,
      refreshData
    );
  };
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Row style={{ maxHeight: 'calc(100vh - 50px)' }}>
        <Col xs={12} lg={12} className="rounded-3">
          <div className="bg-white rounded-3 h-100 d-flex flex-column">
            <Modal.Header
              className="border-0 position-relative pb-0 end-0 dark__text-white px-4 border-bottom d-flex justify-content-between align-items-start"
              closeButton={false}
              // style={{ minWidth: '250px' }}
            >
              <div className="mb-2">
                <h4 className="modal-title mb-2 text-1000">Approval Request</h4>
              </div>

              <div>
                <ToolTipButton
                  onClick={handleClose}
                  size="sm"
                  variant="phoenix-secondary"
                  label="Close modal"
                  className="ms-2"
                >
                  <FontAwesomeIcon icon={faX} />
                </ToolTipButton>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 pb-2">
              <div className="d-flex justify-content-center">
                Do you want to accept or reject the employee's late punch-in
                request?
              </div>
            </Modal.Body>
            <Modal.Footer
              className={`d-flex justify-content-between flex-wrap-reverse`}
            >
              <Button variant="phoenix-secondary" onClick={handleClose}>
                Cancel
              </Button>
              <div className="d-flex gap-1 justify-content-end">
                <Button
                  variant="phoenix-danger"
                  onClick={() => handleReject('reject')}
                >
                  Decline
                </Button>
                <Button
                  variant="phoenix-success"
                  onClick={() => handleApproval('accept')}
                >
                  Accept
                </Button>
              </div>
            </Modal.Footer>
          </div>
        </Col>
      </Row>
    </CustomModal>
  );
};

export default EmployeeLatePunchinDetailModal;
